import React, { useState, useEffect } from "react";
import SiTextField from "../../../../core/si-textfield";
import CustomFilters from "../../../../core/custom-filters";
import { PAGE_LIMIT } from "../../../../utils";
const WSMFilters = ({ loadData, setMainFilters, filter }) => {
  const [filterType, setFilterType] = useState("");
  const [filterValue, setFilterValue] = useState("");

  const applyFilters = (filters) => {
    if (Object.keys(filters).length) {
      const payload = {};
      for (let key in filters) {
        if (typeof filters[key] === "object" && filters[key]?.value) {
          payload[key] = filters[key].value;
        } else {
          payload[key] = filters[key];
        }
      }
      if (setMainFilters) {
        setMainFilters(payload);
      }
      loadData({
        ...payload,
        sortBy: "-createdAt",
        limit: PAGE_LIMIT,
        page: filter?.page || 1,
        approvalStatus: "APPROVED",
      });
    } else {
      if (setMainFilters) {
        setMainFilters({});
      }
      loadData({
        sortBy: "-createdAt",
        limit: PAGE_LIMIT,
        page: filter?.page || 1,
        approvalStatus: "APPROVED",
      });
    }
  };

  const filterTypes = [
    { label: "Filter by Engine Model", value: "engineModel" },
  ];

  const renderFilterInput = () => {
    switch (filterType) {
      case "engineModel":
        return (
          <SiTextField
            placeholder="Engine Model"
            name="engineModel"
            onChange={handleFilterValueChange}
          />
        );

      default:
        return null;
    }
  };

  const handleFilterValueChange = (event) => {
    setFilterValue(event.target.value);
  };

  return (
    <div>
      <CustomFilters
        applyFilters={applyFilters}
        renderFilterInput={renderFilterInput}
        filterTypes={filterTypes}
        filterType={filterType}
        setFilterType={setFilterType}
        filterValue={filterValue}
        setFilterValue={setFilterValue}
      />
    </div>
  );
};

export default WSMFilters;
